import { Container } from '../../components/content';
import styles from '../../styles/subscriptions.module.scss';
import { Link, useParams } from 'react-router-dom';
import ContentLayout from '../../layout/ContentLayout';
import GenericTable from '../../components/tables/GenericTable';
import { formatPriceWithCurrency } from '../../utils/formatPrice';
import React, { useEffect, useState } from 'react';
import { fetchSubscriptionById } from '../../api/subscription-api';
import dayjs from 'dayjs';

const SingleSubscriptionHistory = () => {
  const { id } = useParams();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const { data, success, message } = await fetchSubscriptionById(id);
      if (success) {
        setSubscription(data);
      } else {
        console.error(message || 'Error fetching subscription.');
      }
      setLoading(false);
    };
    load();
  }, [id]);

  const columnsPaymentHistory = [
    {
      key: 'date',
      label: 'Datum',
      render: (val) => <span>{val ? dayjs(val).format('DD.MM.YYYY.') : '-'}</span>,
    },
    {
      key: 'orderId',
      label: 'Broj porudžbine',
      render: (val) => <span>{val || '-'}</span>,
    },
    {
      key: 'status',
      label: 'Status',
      render: (val) => {
        const lowered = val ? val.toLowerCase() : '';
        return (
            <span className={lowered}>
            {lowered === 'success' ? 'Uspešno' : 'Neuspešno'}
          </span>
        );
      },
    },
    {
      key: 'errMsg',
      label: 'Razlog neuspeha',
      render: (val, row) => {
        if (row.status?.toLowerCase() !== 'failed') return <span>-</span>;
        const reason = val || 'Nepoznat razlog';
        const code = row.procReturnCode;
        return (
          <span style={{ color: '#c0392b' }}>
            {reason}{code ? ` (kod ${code})` : ''}
          </span>
        );
      },
    },
    {
      key: 'amount',
      label: 'Iznos',
      render: (val) => <span>{formatPriceWithCurrency(val ?? 0)}</span>,
    },
    {
      key: 'transId',
      label: 'ID Transakcije',
      render: (val) => <span>{val || '-'}</span>,
    },
  ];

  const hasFrozenPaket = subscription?.configurationProducts?.products?.length > 0;

  const buildTableData = () => {
    const regularProducts = subscription?.products ?? [];

    if (!hasFrozenPaket) return regularProducts;

    const configProducts = subscription.configurationProducts.products;
    const totalPrice = subscription.configurationProducts.totalPrice;
    const totalQuantity = configProducts.reduce((sum, p) => sum + (p.quantity ?? 0), 0);

    const originalTotalPrice = configProducts.reduce(
      (sum, p) => sum + (p.originalPriceAtPurchase ?? p.priceAtPurchase) * p.quantity,
      0,
    );

    const frozenPaketRow = {
      _isFrozenPaket: true,
      _configProducts: configProducts,
      _totalQuantity: totalQuantity,
      _totalPrice: totalPrice,
      _originalTotalPrice: originalTotalPrice,
    };

    return [...regularProducts, frozenPaketRow];
  };

  const columnsCurrentProducts = [
    {
      key: 'product',
      label: 'Proizvod',
      render: (val, row) => {
        if (row._isFrozenPaket) {
          return (
              <div>
                <span style={{ fontWeight: 600 }}>Frozen paket</span>
                <div style={{ marginTop: '4px' }}>
                  {row._configProducts.map((p, i) => (
                      <div key={i} style={{ fontSize: '0.85em', color: '#666', lineHeight: '1.6' }}>
                        {p.product?.name || '-'}
                      </div>
                  ))}
                </div>
              </div>
          );
        }
        return <span>{val?.name || '-'}</span>;
      },
    },
    {
      key: 'quantity',
      label: 'Količina',
      render: (val, row) => {
        if (row._isFrozenPaket) {
          return (
              <div>
               {/* <span style={{ fontWeight: 600 }}>Suma {row._totalQuantity}</span>*/}
                <div style={{ marginTop: '4px' }}>
                  {row._configProducts.map((p, i) => (
                      <div key={i} style={{ fontSize: '0.85em', color: '#666', lineHeight: '1.6' }}>
                        {/*{p.quantity ?? '-'}*/}
                      </div>
                  ))}
                </div>
              </div>
          );
        }
        return <span>{val}</span>;
      },
    },
    {
      key: 'priceAtPurchase',
      label: 'Cena',
      render: (val, row) => {
        if (row._isFrozenPaket) {
          const headerPrice = row._originalTotalPrice ?? row._totalPrice ?? 0;
          return (
            <div>
              <span style={{ fontWeight: 600 }}>{formatPriceWithCurrency(headerPrice)}</span>
              <div style={{ marginTop: '4px' }}>
                {row._configProducts.map((p, i) => (
                  <div key={i} style={{ fontSize: '0.85em', color: '#666', lineHeight: '1.6' }}>
                    {formatPriceWithCurrency(p.originalPriceAtPurchase ?? p.priceAtPurchase ?? 0)} x{p.quantity}
                  </div>
                ))}
              </div>
            </div>
          );
        }
        return <span>{formatPriceWithCurrency((row.originalPriceAtPurchase ?? val) ?? 0)}</span>;
      },
    },
    {
      key: 'ukupno',
      label: 'Ukupno',
      render: (val, row) => {
        if (row._isFrozenPaket) {
          const hasDiscount = row._originalTotalPrice && row._originalTotalPrice !== row._totalPrice;
          const pct = hasDiscount
            ? Math.round((1 - row._totalPrice / row._originalTotalPrice) * 100)
            : null;
          return (
            <div>
              {hasDiscount ? (
                <span>
                  <span style={{ textDecoration: 'line-through', color: '#999', marginRight: '6px' }}>
                    {formatPriceWithCurrency(row._originalTotalPrice)}
                  </span>
                  <span style={{ color: '#1a7f37', fontWeight: 600 }}>
                    {formatPriceWithCurrency(row._totalPrice ?? 0)}
                  </span>
                  <span style={{ color: '#1a7f37', fontSize: '0.85em', marginLeft: '4px' }}>
                    (-{pct}%)
                  </span>
                </span>
              ) : (
                <span style={{ fontWeight: 600 }}>{formatPriceWithCurrency(row._totalPrice ?? 0)}</span>
              )}
              <div style={{ marginTop: '4px' }}>
                {row._configProducts.map((p, i) => {
                  const origTotal = (p.originalPriceAtPurchase ?? p.priceAtPurchase) * p.quantity;
                  const discTotal = p.priceAtPurchase * p.quantity;
                  const hasItemDiscount = p.originalPriceAtPurchase && p.originalPriceAtPurchase !== p.priceAtPurchase;
                  if (hasItemDiscount) {
                    return (
                      <div key={i} style={{ fontSize: '0.85em', lineHeight: '1.6' }}>
                        <span style={{ textDecoration: 'line-through', color: '#999', marginRight: '4px' }}>
                          {formatPriceWithCurrency(origTotal)}
                        </span>
                        <span style={{ color: '#1a7f37' }}>
                          {formatPriceWithCurrency(discTotal)}
                        </span>
                        {p.discountPercent && (
                          <span style={{ color: '#1a7f37', marginLeft: '4px' }}>(-{p.discountPercent}%)</span>
                        )}
                      </div>
                    );
                  }
                  return (
                    <div key={i} style={{ fontSize: '0.85em', color: '#666', lineHeight: '1.6' }}>
                      {formatPriceWithCurrency(discTotal)}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }

        const origTotal = (row.originalPriceAtPurchase ?? row.priceAtPurchase) * row.quantity;
        const discTotal = row.priceAtPurchase * row.quantity;
        const hasDiscount = row.originalPriceAtPurchase && row.originalPriceAtPurchase !== row.priceAtPurchase;
        if (hasDiscount) {
          return (
            <span>
              <span style={{ textDecoration: 'line-through', color: '#999', marginRight: '6px' }}>
                {formatPriceWithCurrency(origTotal)}
              </span>
              <span style={{ color: '#1a7f37', fontWeight: 600 }}>
                {formatPriceWithCurrency(discTotal)}
              </span>
              {row.discountPercent && (
                <span style={{ color: '#1a7f37', marginLeft: '4px' }}>(-{row.discountPercent}%)</span>
              )}
            </span>
          );
        }
        return <span>{formatPriceWithCurrency(discTotal)}</span>;
      },
    },
  ];

  const fullName = subscription?.user
      ? `${subscription.user.firstName || ''} ${subscription.user.lastName || ''}`.trim()
      : '-';

  const nextBillingDate = () => {
    const showDate =
      subscription?.status === 'ACTIVE' ||
      subscription?.status === 'PENDING_PAYMENT';
    if (!showDate) {
      return '-';
    }
    return dayjs(subscription?.nextBillingDate).format('DD.MM.YYYY.');
  };

  return (
      <>
        <Container className={styles.subscription}>
          <Link to={'/pretplatnicki-sistem'} className="link_btn">
            <img alt="back image" src="/assets/icons/chevron.svg" />
            <span>Nazad</span>
          </Link>
          <div>
            <ContentLayout pt={true}>
              {loading ? (
                  <p>Učitavanje...</p>
              ) : !subscription ? (
                  <p>Pretplata nije pronađena.</p>
              ) : (
                  <>
                    <div className={`${styles.subscription__inner}`}>
                      <div className={`${styles.subscription__header}`}>
                        <p className={`${styles.introParagraph}`}>
                          <strong>Istorija pretplate:</strong> {fullName}
                        </p>
                        <p className={`${styles.introParagraphRight}`}>
                          <strong>Datum naredne naplate:</strong> {nextBillingDate()}
                        </p>
                      </div>

                      <p className="title">
                        Trenutni proizvodi
                      </p>
                      <GenericTable
                          data={buildTableData()}
                          columns={columnsCurrentProducts}
                          grayTheme={true}
                      />
                      <div style={{ marginTop: '8px', textAlign: 'right', lineHeight: '1.8' }}>
                        {subscription.totalDiscount > 0 && (
                          <p style={{ margin: 0 }}>
                            <strong>Popust:</strong>{' '}
                            -{formatPriceWithCurrency(subscription.totalDiscount)}
                          </p>
                        )}
                        <p style={{ margin: 0 }}>
                          <strong>Dostava:</strong>{' '}
                          {subscription.deliveryFeeRsd > 0
                            ? formatPriceWithCurrency(subscription.deliveryFeeRsd)
                            : 'Besplatno'}
                        </p>
                        <p style={{ margin: 0 }}>
                          <strong>Ukupno:</strong>{' '}
                          {formatPriceWithCurrency(subscription.total ?? 0)}
                        </p>
                      </div>
                    </div>

                    <hr style={{ margin: '40px 0', border: '1px solid #e0e0e0' }} />

                    <p className="title" style={{ marginBottom: '12px' }}>
                      Istorija plaćanja
                    </p>
                    <GenericTable
                        data={subscription.paymentHistory}
                        columns={columnsPaymentHistory}
                        grayTheme={true}
                    />
                  </>
              )}
            </ContentLayout>
          </div>
        </Container>
      </>
  );
};

export default SingleSubscriptionHistory;